import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './EmailLogs.css';

const EmailLogs = ({ isSuperAdmin }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    status: '',
    startDate: '',
    endDate: '',
    limit: 50
  });

  useEffect(() => {
    fetchEmailLogs();
  }, [filters]);

  const fetchEmailLogs = async () => {
    try {
      setLoading(true);
      setError(null);
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      params.append('limit', filters.limit);

      const response = await api.get(`/monitoring/email-logs?${params.toString()}`);
      setLogs(response.data.logs || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch email logs');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusClass = status === 'sent' ? 'status-success' : 'status-error';
    return <span className={`status-badge ${statusClass}`}>{status}</span>;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const formatRecipients = (recipientEmail, ccEmail) => {
    if (!ccEmail) return recipientEmail;
    return (
      <div className="recipients-list">
        <div><strong>To:</strong> {recipientEmail}</div>
        <div><strong>CC:</strong> {ccEmail}</div>
      </div>
    );
  };

  return (
    <div className="email-logs">
      <div className="logs-filters">
        <div className="filter-group">
          <label>Status:</label>
          <select
            value={filters.status}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="">All</option>
            <option value="sent">Sent</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Start Date:</label>
          <input
            type="date"
            value={filters.startDate}
            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
          />
        </div>

        <div className="filter-group">
          <label>End Date:</label>
          <input
            type="date"
            value={filters.endDate}
            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
          />
        </div>

        <div className="filter-group">
          <label>Limit:</label>
          <select
            value={filters.limit}
            onChange={(e) => setFilters({ ...filters, limit: parseInt(e.target.value) })}
          >
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>

        <button className="btn-refresh" onClick={fetchEmailLogs}>
          🔄 Refresh
        </button>
      </div>

      {loading && <div className="loading-message">Loading email logs...</div>}
      {error && <div className="error-message">{error}</div>}

      {!loading && !error && logs.length === 0 && (
        <div className="no-data-message">No email logs found</div>
      )}

      {!loading && !error && logs.length > 0 && (
        <div className="logs-table-container">
          <table className="logs-table">
            <thead>
              <tr>
                <th>Shipment ID</th>
                <th>Recipients</th>
                <th>Type</th>
                <th>Status</th>
                <th>Sent At</th>
                <th>Error Message</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>#{log.shipment_id}</td>
                  <td className="recipients-cell">{formatRecipients(log.recipient_email, log.cc_email)}</td>
                  <td>{log.email_type || 'notification'}</td>
                  <td>{getStatusBadge(log.status)}</td>
                  <td>{formatDate(log.sent_at)}</td>
                  <td className="error-cell">{log.error_message || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EmailLogs;
